const api = {
	listOrganizationStaffAccounts: '/storedValueCard/listOrganizationStaffAccounts',
	listAllDepartments: '/storedValueCard/listAllDepartments',
	changeOrganizationStaffAccountsBalance: '/storedValueCard/changeOrganizationStaffAccountsBalance',
	activateOrganizationStaffAccounts: '/storedValueCard/activateOrganizationStaffAccounts',
	enableOrganizationStaffAccounts: '/storedValueCard/enableOrganizationStaffAccounts',
	disableOrganizationStaffAccounts: '/storedValueCard/disableOrganizationStaffAccounts',
	findOrganizationStaffAccount: '/storedValueCard/findOrganizationStaffAccount',
	findOrganizationAccountInfo: '/storedValueCard/findOrganizationAccountInfo',
	listOrganizationStaffAccountLogs: '/storedValueCard/listOrganizationStaffAccountLogs',
	listOrganizationStaffAccountBalanceChangeLogs: '/storedValueCard/listOrganizationStaffAccountBalanceChangeLogs',
	listOrderSource: '/storedValueCard/listOrderSource',
	exportOrganizationStaffAccountBalanceChangeLogs: '/storedValueCard/exportOrganizationStaffAccountBalanceChangeLogs',
};

export {
	api
};
